import React from 'react'

const Error = () => {
  return (
    <div className='h-screen customContainer'>
      oops
    </div>
  )
}

export default Error
